import { IApiEpBillingPaymentProvider } from "@smp/api";
import { UiBox, UiButtonBase, UiTypography } from "@smp/ui";
import { REACT_APP__URL_STORAGE_STATIC } from "@smp/utils";
import clsx from "clsx";
import { useCallback } from "react";

import { useStyles } from "./payment_provider_card.css";

const urls: Record<IApiEpBillingPaymentProvider["id"], string | undefined> = {
  cloudpayments: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/cloudpayments.svg`,
  maib: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/cloudpayments_aexpress.svg`,
  manual: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/manual.svg`,
  paypal: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/paypal.svg`,
  qiwi: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/qiwi.svg`,
  robokassa: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/robokassa.svg`,
  stub: undefined,
  yakassa: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/yakassa.svg`,
  paddle: `${REACT_APP__URL_STORAGE_STATIC}/images/billing/providers/paddle.svg`,
};

export const PaymentProviderCard = ({
  isActive,
  provider,
  onSelect,
  ...props
}: {
  isActive: boolean;
  provider: IApiEpBillingPaymentProvider;
  onSelect: (provider: IApiEpBillingPaymentProvider) => void;
}) => {
  const classes = useStyles();

  const url = urls[provider.id];

  const handleSelect = useCallback(() => {
    onSelect(provider);
  }, [onSelect, provider]);

  return (
    <UiBox
      alignItems="center"
      className={clsx(classes.card, {
        [classes["card--active"]]: isActive,
      })}
      component={UiButtonBase}
      onClick={handleSelect}
      {...props}
    >
      {url ? (
        <img className={classes.card__image} alt={provider.id} src={url} />
      ) : (
        <UiTypography variant="h4">{provider.id}</UiTypography>
      )}
    </UiBox>
  );
};
